import Cookies from 'js-cookie';
import $ from 'jquery';

const COOKIES_ACCEPT_COOKIE_NOTICE_NAME = 'accept-cookies';
const COOKIE_NOTICE_ACCEPT_ACTION_SELECTOR = '[data-cookie-notice-action]';
const COOKIE_NOTICE_SELECTOR = '[data-cookie-notice]';
const COOKIE_CONSENT_TOGGLE_SELECTOR = '[data-cookie-consent-toggle]';
const GOOGLE_ANALTYICS_COOKIES = [
    '_ga',
    '_gid',
    '_gat',
    'AMP_TOKEN',
    '_gac_'
];
export default class CookieNotice {
    constructor() {
        this.setupEvents();

        this.refreshNotice();

        if (!this.hasAccepted()) {
            this.disableAnalytics();
        }
    }

    setupEvents() {
        $(document).on(
            'click',
            COOKIE_NOTICE_ACCEPT_ACTION_SELECTOR,
            (ev) => {
                this.onCookieAcceptClick(ev);
            }
        );
        $(document).on(
            'change',
            COOKIE_CONSENT_TOGGLE_SELECTOR,
            (ev) => {
                this.toggleCookieAccept(ev);
            }
        );
    }

    hasAccepted() {
        const cookie = Cookies.get(COOKIES_ACCEPT_COOKIE_NOTICE_NAME);

        return cookie && cookie == 'true';
    }

    setAccepted(flag) {
        if (!flag) {
            this.disableAnalytics();
        }

        return Cookies.set(COOKIES_ACCEPT_COOKIE_NOTICE_NAME, flag);
    }

    refreshNotice() {
        if (this.hasAccepted()) {
            $(COOKIE_NOTICE_SELECTOR).remove();    
        }
    }
    
    onCookieAcceptClick(ev) {
        ev.preventDefault();
        $('.cookie-notice').addClass('fade-out');

        setTimeout(() => {
            this.setAccepted(true);
            this.refreshNotice();
        }, 250);
    }

    disableAnalytics() {
        const cookies = Cookies.get();
        Object.keys(cookies).forEach(cookieName => {
            if (GOOGLE_ANALTYICS_COOKIES.indexOf(cookieName) !== -1) {
                Cookies.remove(cookieName, { path: '/', domain: window.location.hostname });
            }
        })
    }

    toggleCookieAccept(ev) {
        ev.preventDefault();
        const $target = $(ev.target);
        const isAccepted = $target.is(':checked');

        this.setAccepted(isAccepted);
    }
}


// WEBPACK FOOTER //
// ./assets/scripts/front/App/CookieNotice.js